const LivingBelowChallenge1HintsText =
    ["There are a total of 4 items that should be moved to the 'Advantages' column.",
     "It may impress your friends and family if you live below your means, " +
        "but it may just be annoying and is not really an advantage.",
     "If you live below your means, you will have money after all of your bills have been paid. " +
     "This will make it easier to get a loan if you need one.",
    ]
   

export default LivingBelowChallenge1HintsText;